import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Action } from "redux-actions";

import { IClientPatch, IPatchAction } from "../../../components/course-author/helpers/patches";
import { ISaveInProgressStateProps } from "../../../components/utils/SaveInProgress";
import * as selectors from "../../../selectors/selectors";
import { IState } from "../../reducer";
import { RequestState } from "../../types/common";
import { fetchInitialData, mount, patchRequest, patchRequestImport, unmount } from "./actions";
import { OrganizationSettingsComponent } from "./OrganizationSettings.component";
import {
  IOrganizationSettingsDispatchProps,
  IOrganizationSettingsStateToProps,
  SettingsOption,
  UploadType,
} from "./types";

type StateProps = IOrganizationSettingsStateToProps & ISaveInProgressStateProps;

const mapStateToProps = (state: IState): StateProps => {
  return {
    accountId: selectors.accountId(state),
    fetchInitialDataStatus: state.App.OrganizationSettings.fetchInitialDataState,
    firstFetch: state.App.OrganizationSettings.fetchInitialDataState === null,
    inProgress: state.App.OrganizationSettings.patchRequestState === RequestState.PENDING,
    initialTab: SettingsOption.Settings,
    isAdmin: selectors.isAdminUser(state),
    organization: state.App.OrganizationSettings.organization,
    organizationAdmins: state.App.OrganizationSettings.organizationAdmins,
    organizationName: state.App.OrganizationSettings.organization?.displayName ?? "",
    uploadError: state.App.OrganizationSettings.patchRequestImportError,
    userName: selectors.accountName(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action<any>>): IOrganizationSettingsDispatchProps => ({
  mount: () => {
    dispatch(mount());
    dispatch(fetchInitialData());
  },
  patchRequest: (patch: IClientPatch<IPatchAction>) => dispatch(patchRequest(patch)),
  unmount: () => dispatch(unmount()),
  uploadCsv: (file: File, uploadType: UploadType) => dispatch(patchRequestImport({ file, uploadType })),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationSettingsComponent);
